import { useState, useEffect, useCallback } from 'react';
import { supabase } from '@/integrations/supabase/client';

export interface MonthlyBillingData {
  month: string;
  label: string;
  arrived: number;
  arrivedPeople: number;
  cancelled: number;
  planned: number;
  total: number;
  arrivalRate: number;
}

interface BillingDataResponse {
  months: MonthlyBillingData[];
}

export function useBillingData() {
  const [data, setData] = useState<MonthlyBillingData[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const fetchBillingData = useCallback(async () => {
    try {
      setLoading(true);
      setError(null);

      const { data: sessionData } = await supabase.auth.getSession();
      if (!sessionData.session) {
        setError('Non authentifié');
        return;
      }

      const response = await supabase.functions.invoke<BillingDataResponse>('get-billing-stats');

      if (response.error) {
        console.error('Error fetching billing data:', response.error);
        setError(response.error.message || 'Erreur lors de la récupération des données');
        return;
      }

      setData(response.data?.months || []);
    } catch (err) {
      console.error('Error in useBillingData:', err);
      setError('Erreur lors de la récupération des données');
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchBillingData();
  }, [fetchBillingData]);

  return { data, loading, error, refetch: fetchBillingData };
}
